import { ScrollArea, ScrollBar } from "@sentricmusic/ui";

import { hasAdminRights } from "../auth/shared";
import SidebarNavItems from "./SidebarNavItems";
import Spacer from "./Spacer";

function Sidebar({
  darkColour,
  highlightColour,
  siteConfig,
  displayAccountData,
  hideRoyalties,
  isTunecore,
  isDesktop = false,
  showKyc,
  showKycPending,
  accounts,
  selectedAccount,
  isAccountSwitching,
}) {
  const adminRights = hasAdminRights(displayAccountData);

  const sidebarStyle = isTunecore
    ? { backgroundColor: "#141414", borderRight: "2px solid #333" }
    : { backgroundColor: darkColour };

  const containerClasses = isDesktop
    ? "fixed flex flex-col w-full lg:w-60 lg:min-w-60 lg:max-w-60"
    : "h-screen overflow-y-scroll lg:overflow-visible";

  return (
    <div style={sidebarStyle} className={containerClasses}>
      {!adminRights && isTunecore && (
        <div className="absolute flex items-center justify-center w-full px-2 py-2 text-base bg-opacity-40 lg:rounded-br-lg auto bg-action-primary">
          This site is in read-only mode
        </div>
      )}

      {isDesktop && (
        <div
          className={`flex items-center justify-center px-5 align-center mb-14 ${
            adminRights && isTunecore ? "mt-10" : "mt-8"
          }`}
        >
          {siteConfig?.logo && (
            <img className="h-6 lg:h-12" src={siteConfig.logo} alt="logo" />
          )}
        </div>
      )}

      {isDesktop ? (
        <ScrollArea className="hidden sidenav lg:block h-screen-minus-side-header">
          <SidebarNavItems
            darkColour={darkColour}
            highlightColour={highlightColour}
            siteConfig={siteConfig}
            hideRoyalties={hideRoyalties}
            accounts={accounts}
            selectedAccount={selectedAccount}
            isAccountSwitching={isAccountSwitching}
          />
          <ScrollBar orientation="vertical" />
        </ScrollArea>
      ) : (
        <>
          <Spacer />
          <SidebarNavItems
            darkColour={darkColour}
            highlightColour={highlightColour}
            siteConfig={siteConfig}
            hideRoyalties={hideRoyalties}
            accounts={accounts}
            selectedAccount={selectedAccount}
            isAccountSwitching={isAccountSwitching}
          />
          <div className={showKyc || showKycPending ? "h-56" : "h-44"} />
        </>
      )}
    </div>
  );
}

export default Sidebar;
